<template>
    <ModalTopSummary>
        <template #name>
            <span class="modal-top-summary__title --name">{{ course.title }}</span>
            <span class="modal-top-summary__type-and-duration">
                {{ course.type }} - {{ courseDuration }}
            </span>
            <div>
                <span class="modal-top-summary__details-label" v-html="$t('OrganizationReport.trainer')"></span>
                <span class="modal-top-summary__details-data">{{ course.instructor }}</span>
            </div>
            <div>
                <span class="modal-top-summary__details-label" v-html="$t('OrganizationReport.level')"></span>
                <span class="modal-top-summary__details-data" v-html="$t(`Select.skill_level_${course.level}`)"></span>
            </div>
        </template>
        <template #completed>
            {{ course.totalCompleted }}
        </template>
        <template #uncompleted>
            {{ course.totalUncompleted }}
        </template>
        <template #totalWatched>
            {{ totalMinutesWatched }}
        </template>
        <template #authorizations>
            <span class="modal-top-summary__badge" v-for="(auth, index) in course.authorizationTypes" :key="index">
                {{ auth.credits }} {{  uppercase(auth.label) }}
            </span>
        </template>
        <template #categories>
            <div>
                <span class="modal-top-summary__details-label" v-html="$t('OrganizationReport.subject_areas')"></span>
                <span class="modal-top-summary__details-data" v-for="(singlePackage, index) in course.packages" :key="index">{{ singlePackage }}</span>
            </div>
            <div>
                <span class="modal-top-summary__details-label" v-html="$t('OrganizationReport.categories')"></span>
                <span class="modal-top-summary__details-data" v-for="(category, index) in course.categories" :key="index">{{ category }} </span>
            </div>
        </template>
    </ModalTopSummary>
</template>

<script>
import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
import ModalTopSummary from 'components/user/organizationreport/modals/ModalTopSummary'
export default {
    name: 'course-table-summary',
    props:{
        course: {
            type: Object
        }
    },
    components: { ModalTopSummary },
    mixins: [convertMinutesToHours],
    computed: {
        totalMinutesWatched () {
            return this.convertMinutesToHours(this.course.totalMinutesWatched)
        },
        courseDuration () {
            return this.convertMinutesToHours(this.course.duration)
        }
    },
    methods: {
        uppercase (auth) {
            return auth?.toUpperCase()
        }
    }
}
</script>
